import React, { Fragment } from 'react';
import styled, { css } from 'styled-components';
import parse from 'html-react-parser';
import Icon from '../shared/Icon';
import Text from '../shared/Text';
import { breakpoints } from '../../constants/styles';


const Badge = styled.div`
  display: flex;
  align-items: center;
  height: 25px;
  align-content: flex-start;
  justify-content: flex-start;
  padding: 2px 10px;
  border-radius: 30px;

  ${({ color }) => color && css`
    background-color: ${color};
  `};

  width: 100%;
  min-width: 115px;
  max-width: 115px;

  ${breakpoints.mobileLandscape} {
    height: 30px
  }
`;

const Container = styled.div`
  display: flex;
  height: fit-content;
  width: 100%;
  flex-direction: row;
  align-items: center;
`;

const customIcon = css`
  height: 20px;
  width: 20px;

  ${breakpoints.mobileLandscape} {
    height: 25px;
    width: 25px;
  }
`;

const StatusCard = ({
  color, icon, label, text,
}) => (
  <Container>
    <Badge color={color}>
      <Icon icon={icon} color="white" style={{ marginRight: '10px' }} styles={customIcon} />
      <Text type="pills" medium>
        {label}
      </Text>
    </Badge>
    <div>
      <Text
        style={{
          padding: '0px 10px',
          width: '95%',
        }}
      >
        { parse(`${text}`) }
      </Text>
    </div>
  </Container>
);

export default StatusCard;
